import {createStore, combineReducers, applyMiddleware} from 'redux';
import { thunk } from 'redux-thunk';
// import { createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' 
import UserReducer from './reducers/userReducer';
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'user']
}

const rootReducer = combineReducers({
  user: UserReducer,
});
  const persistedReducer = persistReducer(persistConfig, rootReducer)
// const configureStore = () => {
//   let store = createStore(persistedReducer)
//   let persistor = persistStore(store)
//   return { store, persistor }
//   // return createStore(rootReducer, applyMiddleware(thunk));
// };

const configureStore = () => {
  const store = createStore(
    persistedReducer,
    applyMiddleware(thunk) // Apply thunk middleware here
  );
  const persistor = persistStore(store);
  return { store, persistor };
};

export default configureStore;